import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';
import { HomeIcon, MessageCircleIcon, BookOpenIcon, UsersIcon, HelpCircleIcon } from 'lucide-react';
const BottomNavigation = () => {
  const navItems = [{
    to: '/',
    icon: <HomeIcon size={28} data-id="element-31" />,
    label: 'Home'
  }, {
    to: '/chat',
    icon: <MessageCircleIcon size={28} data-id="element-32" />,
    label: 'Chat'
  }, {
    to: '/memory',
    icon: <BookOpenIcon size={28} data-id="element-33" />,
    label: 'Journal'
  }, {
    to: '/family',
    icon: <UsersIcon size={28} data-id="element-34" />,
    label: 'Family'
  }, {
    to: '/help',
    icon: <HelpCircleIcon size={28} data-id="element-35" />,
    label: 'Help'
  }];
  return <div className="fixed bottom-0 left-0 right-0 bg-white dark:bg-slate-800 border-t border-gray-200 dark:border-slate-700 pb-safe shadow-soft" data-id="element-36">
      <nav className="flex justify-around items-center h-20 max-w-md mx-auto" data-id="element-37">
        {navItems.map(item => <NavLink key={item.to} to={item.to} className={({
        isActive
      }) => `
              flex flex-col items-center justify-center w-full h-full py-2 px-1
              ${isActive ? 'text-lavender dark:text-lavender/90' : 'text-gray-500 dark:text-gray-400'}
            `} data-id="element-38">
            {item.icon}
            <span className="text-sm mt-1 font-medium" data-id="element-39">{item.label}</span>
          </NavLink>)}
      </nav>
    </div>;
};
export default BottomNavigation;